import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import Button from "../components/Button";
import { sponsors2026 } from "../data/sponsors";
import { festival } from "../data/festival";
import { IconExternal } from "../components/icons";
import styles from "./Sponsors.module.css";

const subNav = [
  { label: "Participate", path: "/participate", end: true },
  { label: "Get Involved", path: "/participate/get-involved" },
  { label: "Vending", path: "/participate/vending" },
  { label: "Sponsors", path: "/participate/sponsors" },
];

export default function Sponsors() {
  return (
    <>
      <PageHero
        eyebrow="Partner with the festival"
        title="Sponsors"
        lede="Custom sponsorship packages — on-site activations, stage naming, digital promotion. Every sponsor dollar funds music education for valley kids."
        image="/photos/festival-1.jpg"
      />
      <SubNav items={subNav} />

      <Page>
        <section className={styles.cta}>
          <div className={styles.ctaText}>
            <h2 className={styles.ctaTitle}>Let's build something together.</h2>
            <p>
              We work with brands and businesses on customized partnerships — from
              sampling tents and on-site activations to stage naming and pre-event
              digital campaigns. Every package is built around your goals (and ours).
            </p>
          </div>
          <div className={styles.ctaActions}>
            <Button href={`mailto:${festival.emailSponsor}`} variant="primary">
              Sponsor 2026
            </Button>
            <Button href={`mailto:${festival.email}`} variant="outline">
              Request a Deck
            </Button>
          </div>
        </section>

        <h2 className={styles.h2}>2026 Partners</h2>
        <div className={styles.grid}>
          {sponsors2026.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener"
              className={styles.card}
            >
              <div className={styles.logoWrap}>
                {s.logo ? (
                  <img src={s.logo} alt={`${s.name} logo`} />
                ) : (
                  <span className={styles.logoText}>{s.name}</span>
                )}
              </div>
              <h3 className={styles.name}>{s.name}</h3>
              <p className={styles.blurb}>{s.blurb}</p>
              <span className={styles.visit}>Visit <IconExternal /></span>
            </a>
          ))}
        </div>

        <section className={styles.benefits}>
          <h3 className={styles.h3}>Where Your Sponsorship Goes</h3>
          <ul>
            <li>Stringed instruments distributed to children across the San Luis Valley</li>
            <li>Free music lessons, paid for participating instructors</li>
            <li>Performance venues for student recitals</li>
            <li>Workshop scholarships and program materials</li>
            <li>Three days of music for thousands of festival-goers in Del Norte</li>
          </ul>
        </section>
      </Page>
    </>
  );
}
